import React, { createContext, useContext, useState, useEffect } from "react";
import { Settings } from "../types";
import { settingsService } from "../services/dataService";

interface SettingsContextType {
  settings: Settings | null;
  loading: boolean;
  refreshSettings: () => Promise<void>;
}

const SettingsContext = createContext<SettingsContextType | undefined>(
  undefined,
);

export const SettingsProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [settings, setSettings] = useState<Settings | null>(null);
  const [loading, setLoading] = useState(true);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const data = await settingsService.getDefault();
      setSettings(data);
    } catch (error) {
      console.error("❌ Ayarlar yüklenirken hata:", error);
      // Varsayılan değerler
      setSettings({
        settingsId: "",
        settingsName: "Varsayılan",
        profitMargin: 40,
        overheadCostRate: 40,
        // Ayarlar okunamadıysa müşteriye posta gönderme: varsayılan güvenli taraf.
        notifyCustomerByEmail: false,
        // Ayarlar okunamadıysa girişsiz randevu sayfası da kapalı sayılır.
        publicBookingEnabled: false,
        auditRetentionDays: 90,
        pricesIncludeVat: false,
        defaultVatRate: 20,
        vatRates: "0,1,10,20",
        faturasizSeriesCode: "PRF",
        defaultPaymentTermDays: 30,
        isActive: true,
        createdAt: new Date().toISOString(),
        createdBy: "",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const refreshSettings = async () => {
    await loadSettings();
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (context === undefined) {
    throw new Error("useSettings must be used within a SettingsProvider");
  }
  return context;
};
